import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

export const EVENTS = {
	CLOSED: 'closed',
	OPENED: 'opened'
};

function WindowBridge({
	                      render,
	                      url,
	                      bridge,
	                      name = `5pbxPopup${Date.now() + '_' + Math.random()}`,
	                      resizable = 1,
	                      status = 0,
	                      dependent = 1,
	                      scrollbars,
	                      location = 0,
	                      menubar = 0,
	                      toolbar = 0,
	                      alwaysRaised = 1,
	                      width = 300,
	                      height = 300,
	                      alwaysOnTop = true
                      }) {

	const [popup, setPopup] = useState(null);
	const [state, setState] = useState(null);
	// const [alwaysOnTopChecker, setAlwaysOnTopChecker] = useState(0);
	// const [alwaysOnTopCheckerInt, setAlwaysOnTopCheckerInt] = useState(null);

	useEffect(() => {
		state && bridge(state);
	}, [state, bridge]);

	useEffect(() => {
		if (!popup) {
			setState(EVENTS.CLOSED);
		} else {
			if (typeof popup.focus === 'function') {
				popup.focus();
			}
		}
	}, [popup]);

	// useEffect(() => {
	// 	if (alwaysOnTop && !alwaysOnTopChecker && !alwaysOnTopCheckerInt) {
	// 		setAlwaysOnTopCheckerInt(setInterval(() => {
	// 			setAlwaysOnTopChecker(Date.now());
	// 			if (popup && typeof popup.focus === 'function') {
	// 				popup.focus();
	// 			}
	// 		}, 1000 * 2));
	// 	} else {
	// 		setAlwaysOnTopChecker(null);
	// 	}
	// }, [popup, alwaysOnTop, alwaysOnTopChecker, alwaysOnTopCheckerInt])
	
	useEffect(() => {
			if (popup && typeof popup.focus === 'function') {
				popup.focus();
			}
		},
		[popup]
	);

	const openPopup = () => {
		const newPopup = window.self.open(url, name, `status=${status}, resizable=${resizable}, scrollbars=${scrollbars}, menubar=${menubar}, toolbar=${toolbar}, location=${location}, dependent=${dependent}, alwaysOnTop=${alwaysOnTop}, alwaysRaised=${alwaysRaised}, width=${width}, height=${height}`);
		newPopup.onload = () => {
			setState(EVENTS.OPENED);
			setPopup(newPopup);
		};
		newPopup.onbeforeunload = () => setPopup(null);
	}

	return render({openPopup, url});

}

WindowBridge.defaultProps = {
	render: PropTypes.func.isRequired,
	name: PropTypes.string,
	url: PropTypes.string.isRequired,
	bridge: PropTypes.func.isRequired,
	alwaysOnTop: PropTypes.bool,
	alwaysRaised: PropTypes.number,
	dependent: PropTypes.number,
	status: PropTypes.number,
	resizable: PropTypes.number,
	scrollbars: PropTypes.number,
	menubar: PropTypes.number,
	toolbar: PropTypes.number,
	location: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number
};

export default WindowBridge;